<p-toast />
<p-confirmPopup>
    <ng-template pTemplate="content" let-message>
        <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border p-3 mb-3">
            <i [class]="message.icon" class="text-6xl text-primary-500"></i>
            <p>{{ message.message }}</p>
        </div>
    </ng-template>
</p-confirmPopup>

@if (campaign != null) {
<p-toolbar styleClass="mb-4 gap-2 top-action-bar" [style]="{'z-index': '2'}">
    <ng-template pTemplate="left">
        <div class="flex align-items-center gap-2">
            @if (campaign.isActive) {
            <label>Published At: {{campaign.dateActivated | date : 'medium'}}</label>
            }
            @if (canActivate()) {
            <p-button severity="success" label="Activate" icon="pi pi-check" class="mr-2"
                (onClick)="activate($event)" />
            }

            @if (canDeactivate()) {
            <p-button severity="warn" label="Deactivate" icon="pi pi-check" class="mr-2"
                (onClick)="deactivate($event)" />
            }

            @if (canclean()) {
            <p-button severity="danger" label="Cleanup Pipedrive Deals" icon="pi pi-check" class="mr-2"
                (onClick)="clean($event)" />
            }
        </div>
    </ng-template>

    <ng-template pTemplate="right">
        <p-button severity="primary" label="Save" icon="pi pi-save" class="mr-2" (onClick)="save($event)" />
        <p-button severity="secondary" label="Exit" icon="pi pi-arrow-circle-left" class="mr-2" (onClick)="exit()" />
    </ng-template>
</p-toolbar>

<div class="grid">

    <div class="col-12 xl:col-4">
        <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-2 w-full">
                <label for="name">Name</label>
                <input pInputText id="name" aria-describedby="name-help" [(ngModel)]="campaign.name" />
            </div>

            <div class="gap-3">
                <div class="flex flex-column gap-2">
                    <label for="createAllDealsAtActivation">Create Deals At Activation</label>
                    <p-inputSwitch id="createAllDealsAtActivation" [(ngModel)]="campaign.createAllDealsAtActivation" />
                </div>

                @if (campaign.createAllDealsAtActivation) {
                <div class="flex flex-column gap-2 w-full">
                    <label for="crmAudienceFilterId">Pipedrive Audience Filter Id (Organiation filter to select
                        organizations than will create deal)</label>
                    <input pInputText id="crmAudienceFilterId" aria-describedby="name-help"
                        [(ngModel)]="campaign.crmAudienceFilterId" />
                </div>

                <div class="flex flex-column gap-2 w-full">
                    <label for="crmInitialStageIndex">Pipedrive Initial Stage Index</label>
                    <p-inputNumber id="crmInitialStageIndex" styleClass="w-full" [maxFractionDigits]="0"
                        [(ngModel)]="campaign.crmInitialStageIndex" />
                </div>
                }
            </div>

            <div class="flex flex-column gap-2">
                <label for="crmCampaign">Handle Deals after CTA button is clicked</label>
                <p-inputSwitch id="crmCampaign" [(ngModel)]="campaign.crmCampaign" />
            </div>

            @if (campaign.crmCampaign) {
            <div class="flex flex-column gap-2 w-full">
                <label for="crmUserClickedFilterId">Pipedrive Clicked Filter Id</label>
                <input pInputText id="crmUserClickedFilterId" aria-describedby="name-help"
                    [(ngModel)]="campaign.crmUserClickedFilterId" />
            </div>

            <div class="flex flex-column gap-2 w-full">
                <label for="crmClickedStageIndex">Pipedrive Clicked Stage Index</label>
                <p-inputNumber id="crmClickedStageIndex" styleClass="w-full" [maxFractionDigits]="0"
                    [(ngModel)]="campaign.crmClickedStageIndex" />
            </div>
            }

            <div class="flex flex-column gap-2">
                <label for="iHostCampaign">Promo Campaign through iHost Pocket</label>
                <p-inputSwitch id="iHostCampaign" [(ngModel)]="campaign.iHostCampaign" />
            </div>
        </div>
    </div>
    <div class="col-12 xl:col-8">
        <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-2 w-full">
                <label for="crmLabelName">Pipedrive Deal Label</label>
                <input pInputText id="crmLabelName" aria-describedby="name-help" [(ngModel)]="campaign.crmLabelName" />
            </div>
            <div class="flex flex-column gap-2 w-full">
                <label for="crmFlowId">Pipedrive Deal Pipeline</label>
                <p-dropdown [options]="flowOptions" [(ngModel)]="campaign.crmFlowId" optionLabel="label"
                    optionValue="value" placeholder="Select Pipeline" styleClass="w-full" />
            </div>
            <div class="flex flex-column gap-2 w-full">
                <label for="crmInitialStageIndex">Pipedrive Deal Products</label>
                <p-table [value]="campaign.lines" styleClass="p-datatable-striped" [tableStyle]="{'min-width': '50rem'}"
                    dataKey="id">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th>Pipedrive Product Id</th>
                            <th>Item Price</th>
                            <th>Discount %</th>
                            <th>Quantity</th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item let-columns="columns">
                        <tr>
                            <td>
                                <p-inputNumber styleClass="w-full" [maxFractionDigits]="0"
                                    [(ngModel)]="item.crmProductId" />
                            </td>
                            <td>
                                <p-inputNumber styleClass="w-full" [maxFractionDigits]="2"
                                    [(ngModel)]="item.itemPrice" />
                            </td>
                            <td>
                                <p-inputNumber styleClass="w-full" [min]="1" [maxFractionDigits]="0"
                                    [(ngModel)]="item.discountPercentage" />
                            </td>
                            <td>
                                <p-inputNumber styleClass="w-full" [min]="1" [maxFractionDigits]="0"
                                    [(ngModel)]="item.quantity" />
                            </td>
                            <td>
                                <p-button icon="pi pi-trash" class="mr-2" [rounded]="true" [outlined]="true"
                                    severity="danger" (onClick)="removeLine(item)" />
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer" let-columns>
                        <tr>
                            <td colspan="10" class="text-center">
                                <p-button label="Add" (onClick)="addLine()" />
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            @if (campaign.iHostCampaign) {
            <div class="flex flex-column gap-2 w-full">
                <label>Description (used on iHost Pocket in app notifications)</label>
                <p-tabView>
                    <p-tabPanel *ngFor="let tab of campaign.description" [header]="tab.lang">
                        <p>
                            <p-editor [(ngModel)]="tab.value" [style]="{ height: '220px' }" />
                        </p>
                    </p-tabPanel>
                </p-tabView>
            </div>
            }
        </div>
    </div>

</div>
} @else {
<p-skeleton height="2rem" styleClass="mb-2" />
}